var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FindMemberIds'),_c('FindSurrogateId'),_c('BasicStatisticsRow',{attrs:{"basicstatisticspath":"/2.0/newbe/statistics/surrogates?sessionid="}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }